module.exports = __webpack_public_path__ + "static/bg_texture-777805fbb437bc053574ffde1be58864.png";